import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "company_container" }
const _hoisted_2 = { class: "company_content" }
const _hoisted_3 = { class: "company_content_box" }
const _hoisted_4 = { class: "company_block_box" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "company_scroll_box" }
const _hoisted_7 = { class: "fw_box" }
const _hoisted_8 = { class: "bxslider" }
const _hoisted_9 = { class: "company_scroll_list" }
const _hoisted_10 = { class: "bxslider" }
const _hoisted_11 = { class: "company_scroll_list" }
const _hoisted_12 = { class: "bxslider" }
const _hoisted_13 = { class: "company_scroll_list" }
const _hoisted_14 = { class: "bxslider" }
const _hoisted_15 = { class: "company_scroll_list" }
const _hoisted_16 = {
  class: "tanchu",
  style: {"display":"block"}
}
const _hoisted_17 = { class: "tc_bj" }
const _hoisted_18 = { style: {"padding":"30px","overflow":"hidden"} }
const _hoisted_19 = ["title", "href"]

import {onBeforeMount, reactive, ref} from 'vue';
import {useRouter} from 'vue-router';
import {Swiper, SwiperSlide} from 'swiper/vue/swiper-vue';
import 'swiper/swiper.css';
import SwiperCore, {Autoplay, Grid, Pagination, EffectCoverflow, Navigation} from "swiper";
import {getForeignCapital} from "@/config/request";


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

SwiperCore.use([Autoplay, Grid, Pagination, EffectCoverflow, Navigation]);
// swiper相关配置属性放在swiper_options这个变量里
let swiper_options = reactive({
    autoplay: true,
    slidesPerView: 4,
    centeredSlides: false,  // true为居中
    spaceBetween: 45,  // 元素间距
    loop: true,
    observer: true,
    observeParents: true,
    speed: 300,
    loopedSlides: 30,
    slidesPerGroup: 1,
    paginationClickable: true,
    grid: {rows: 1, fill: 'row'},
    pagination: {
        el: '.swiper-pagination'
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
    }
});
const isShow = ref(false);
const bankList = ref([
    {
        bankId: "1",
        bankName: '建设银行',
        serviceCode: "Z231018XK6471Q001",
        tagName: "银行开户、外汇登记（建设银行）",
        url:"https://ftz.kaifeng.gov.cn/news-detail?id=1718807143504723969"
    },
    {
        bankId: "2",
        bankName: '中国银行',
        serviceCode: "Z231018XK7870Y001",
        tagName: "银行开户、外汇登记（中国银行）",
        url:"https://ftz.kaifeng.gov.cn/news-detail?id=1718807792569073665"
    }
])
const router = useRouter()
const toWorkGuide = (serviceCode: any,serviceName: any, tagName: any) => {
    router.push({
        path: '/do-things-online/work-guide',
        query: {
            serviceCode: serviceCode,
            serviceName: serviceName,
            tagName: tagName,
        },
    })
    // toDeclaration(serviceCode,serviceName);

}
const toDeclaration = (serviceCode:any,serviceName: any) => {
  let query = {
    serviceCode: serviceCode,
    serviceName: serviceName,
    tagName: 'wzqy',
  } as any
  router.push({
    path: '/do-things-online/notic',
    query: query,
  })
}
const selectBank = () => {
    isShow.value = true;
}
const closeDialog = () => {
    isShow.value = false;
}
const foreignList = ref([]);
const getForeignList = async () => {
    const param = {
        tagName: '外资企业开办一站式服务体系',
        pageNo: 1,
        pageSize: 5
    }
    const res = await getForeignCapital(param) as any
    foreignList.value = res.result?.records
}
onBeforeMount( async () => {
    await getForeignList();
})

return (_ctx: any,_cache: any) => {
  const _component_Top = _resolveComponent("Top")!
  const _component_Bottom = _resolveComponent("Bottom")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Top, { fixedNobanner: true }),
    _cache[32] || (_cache[32] = _createElementVNode("div", {
      class: "no_banner",
      id: "no_banner"
    }, null, -1)),
    _createElementVNode("div", _hoisted_1, [
      _cache[28] || (_cache[28] = _createElementVNode("h1", { class: "company_title" }, [
        _createElementVNode("span", null, [
          _createElementVNode("img", { src: "/images/company_title.png" }),
          _createTextVNode(" 外资企业开办一站式服务体系 ")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        _cache[24] || (_cache[24] = _createElementVNode("h2", { class: "company_title2" }, "未办理营业执照(一次性统一办)", -1)),
        _cache[25] || (_cache[25] = _createElementVNode("h3", { class: "company_title3" }, "未办理营业执照可由此处申请办理", -1)),
        _createElementVNode("div", _hoisted_3, [
          (foreignList.value.length > 0)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(foreignList.value, (item) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("p", null, _toDisplayString(item.serviceName), 1),
                  _cache[4] || (_cache[4] = _createElementVNode("p", null, [
                    _createElementVNode("small", null, "0.5个"),
                    _createTextVNode("工作日办结")
                  ], -1)),
                  _createElementVNode("a", {
                    onClick: ($event: any) => (toWorkGuide(item.serviceCode,item.serviceName,item.tagName))
                  }, "去办理", 8, _hoisted_5),
                  _cache[5] || (_cache[5] = _createElementVNode("img", { src: "/images/company1.png" }, null, -1))
                ]))
              }), 256))
            : _createCommentVNode("", true),
          _cache[6] || (_cache[6] = _createStaticVNode("<div class=\"company_block_lc\" data-v-ce4d20da><span class=\"smalltil\" data-v-ce4d20da><img src=\"/images/xiaotu.png\" data-v-ce4d20da>企业开办流程</span><div class=\"company_block_lc_con\" data-v-ce4d20da><div class=\"lc_btn\" data-v-ce4d20da>开办企业申请</div><span class=\"arrow\" data-v-ce4d20da></span><div class=\"lc_block\" data-v-ce4d20da><img src=\"/images/lc_block_l.png\" data-v-ce4d20da><div class=\"lc_block_con\" data-v-ce4d20da><a data-v-ce4d20da>营业执照申领</a><a data-v-ce4d20da>社保登记</a><a data-v-ce4d20da>住房公积金开户登记</a><a data-v-ce4d20da>印章刻制备案</a><a data-v-ce4d20da>税务发票申领</a><a data-v-ce4d20da>银行开户</a></div><img src=\"/images/lc_block_r.png\" data-v-ce4d20da></div><div class=\"lc_btn\" data-v-ce4d20da>多部门串并联审批</div><span class=\"arrow\" data-v-ce4d20da></span><div class=\"lc_btn\" data-v-ce4d20da>领取执照、印章、发票</div></div></div>", 1))
        ]),
        _cache[26] || (_cache[26] = _createElementVNode("h2", { class: "company_title2" }, "印章刻制、申领发票、银行开户、参保登记等(分段随时办)", -1)),
        _cache[27] || (_cache[27] = _createElementVNode("h3", { class: "company_title3" }, " 办理营业执照后，可在这里随时进行首次申办印章刻制、银行开户、申领发票、职工参保登记等业务。", -1)),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _cache[22] || (_cache[22] = _createElementVNode("div", {
              class: "swiper-button-prev",
              style: {"top":"920px"}
            }, [
              _createElementVNode("svg", {
                t: "1641887663985",
                class: "icon",
                viewBox: "0 0 1024 1024",
                version: "1.1",
                xmlns: "http://www.w3.org/2000/svg",
                "p-id": "6681",
                width: "50",
                height: "50"
              }, [
                _createElementVNode("path", {
                  d: "M512 149.333333c200.298667 0 362.666667 162.368 362.666667 362.666667s-162.368 362.666667-362.666667 362.666667S149.333333 712.298667\r\n                      149.333333 512 311.701333 149.333333 512 149.333333z m42.666667 168.085334L360.085333 512 554.666667 706.581333 599.914667\r\n                      661.333333l-149.333334-149.333333 149.333334-149.333333L554.666667 317.418667z",
                  "p-id": "6682",
                  fill: "#ddd"
                })
              ])
            ], -1)),
            _cache[23] || (_cache[23] = _createElementVNode("div", {
              class: "swiper-button-next",
              style: {"top":"920px"}
            }, [
              _createElementVNode("svg", {
                t: "1641887663985",
                class: "icon",
                viewBox: "0 0 1024 1024",
                version: "1.1",
                xmlns: "http://www.w3.org/2000/svg",
                "p-id": "6681",
                width: "50",
                height: "50"
              }, [
                _createElementVNode("path", {
                  d: "M512 149.333333c200.298667 0 362.666667 162.368 362.666667 362.666667s-162.368 362.666667-362.666667 362.666667S149.333333 712.298667\r\n                      149.333333 512 311.701333 149.333333 512 149.333333z m42.666667 168.085334L360.085333 512 554.666667 706.581333 599.914667\r\n                      661.333333l-149.333334-149.333333 149.333334-149.333333L554.666667 317.418667z",
                  "p-id": "6682",
                  fill: "#ddd"
                })
              ])
            ], -1)),
            _createVNode(_unref(Swiper), {
              pagination: _unref(swiper_options).pagination,
              loop: _unref(swiper_options).loop,
              navigation: _unref(swiper_options).navigation,
              spaceBetween: _unref(swiper_options).spaceBetween,
              centeredSlides: _unref(swiper_options).centeredSlides,
              slidesPerView: _unref(swiper_options).slidesPerView,
              slidesPerGroup: _unref(swiper_options).slidesPerGroup
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(SwiperSlide), null, {
                  default: _withCtx(() => [
                    _createElementVNode("ul", _hoisted_8, [
                      _createElementVNode("li", _hoisted_9, [
                        _cache[7] || (_cache[7] = _createElementVNode("p", null, "社保登记", -1)),
                        _cache[8] || (_cache[8] = _createElementVNode("p", null, [
                          _createElementVNode("small", null, "0.5个"),
                          _createTextVNode("工作日办结")
                        ], -1)),
                        _createElementVNode("a", {
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (toWorkGuide('Z231018XK1892G001','社保登记','wzqy')))
                        }, "去办理"),
                        _cache[9] || (_cache[9] = _createElementVNode("img", { src: "/images/company2.png" }, null, -1))
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(SwiperSlide), null, {
                  default: _withCtx(() => [
                    _createElementVNode("ul", _hoisted_10, [
                      _createElementVNode("li", _hoisted_11, [
                        _cache[10] || (_cache[10] = _createElementVNode("p", null, "刻章备案", -1)),
                        _cache[11] || (_cache[11] = _createElementVNode("p", null, [
                          _createElementVNode("small", null, "0.5个"),
                          _createTextVNode("工作日办结")
                        ], -1)),
                        _createElementVNode("a", {
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (toWorkGuide('Z231018XK6503N001','刻章备案','wzqy')))
                        }, "去办理"),
                        _cache[12] || (_cache[12] = _createElementVNode("img", { src: "images/company3.png" }, null, -1))
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(SwiperSlide), null, {
                  default: _withCtx(() => [
                    _createElementVNode("ul", _hoisted_12, [
                      _createElementVNode("li", _hoisted_13, [
                        _cache[13] || (_cache[13] = _createElementVNode("p", null, "税务发票申领", -1)),
                        _cache[14] || (_cache[14] = _createElementVNode("p", null, [
                          _createElementVNode("small", null, "0.5个"),
                          _createTextVNode("工作日办结")
                        ], -1)),
                        _createElementVNode("a", {
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (toWorkGuide('Z231018XK4943J001','税务发票申领','wzqy')))
                        }, "去办理"),
                        _cache[15] || (_cache[15] = _createElementVNode("img", { src: "images/company4.png" }, null, -1))
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(SwiperSlide), null, {
                  default: _withCtx(() => [
                    _createElementVNode("ul", { class: "bxslider" }, [
                      _createElementVNode("li", { class: "company_scroll_list" }, [
                        _cache[16] || (_cache[16] = _createElementVNode("p", null, "银行开户", -1)),
                        _cache[17] || (_cache[17] = _createElementVNode("p", null, [
                          _createElementVNode("small", null, "0.5个"),
                          _createTextVNode("工作日办结")
                        ], -1)),
                        _createElementVNode("a", { onClick: selectBank }, "去办理"),
                        _cache[18] || (_cache[18] = _createElementVNode("img", { src: "images/company5.png" }, null, -1))
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(SwiperSlide), null, {
                  default: _withCtx(() => [
                    _createElementVNode("ul", _hoisted_14, [
                      _createElementVNode("li", _hoisted_15, [
                        _cache[19] || (_cache[19] = _createElementVNode("p", null, "公积金登记", -1)),
                        _cache[20] || (_cache[20] = _createElementVNode("p", null, [
                          _createElementVNode("small", null, "0.5个"),
                          _createTextVNode("工作日办结")
                        ], -1)),
                        _createElementVNode("a", {
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (toWorkGuide('Z231018XK1061M001','公积金登记','wzqy')))
                        }, "去办理"),
                        _cache[21] || (_cache[21] = _createElementVNode("img", { src: "images/company6.png" }, null, -1))
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["pagination", "loop", "navigation", "spaceBetween", "centeredSlides", "slidesPerView", "slidesPerGroup"])
          ])
        ])
      ])
    ]),
    _createVNode(_component_Bottom),
    (isShow.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("h2", null, [
                _createElementVNode("a", { onClick: closeDialog }),
                _cache[29] || (_cache[29] = _createElementVNode("span", { class: "t2_zt1" }, null, -1)),
                _cache[30] || (_cache[30] = _createTextVNode("请您选择要开户的银行 ", -1))
              ]),
              _createElementVNode("div", _hoisted_18, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bankList.value, (item) => {
                  return (_openBlock(), _createElementBlock("a", {
                    class: "areaClass",
                    title: item.bankName,
                    href: item.url,
                    target: "_blank"
                  }, _toDisplayString(item.bankName), 9, _hoisted_19))
                }), 256))
              ])
            ])
          ]),
          _cache[31] || (_cache[31] = _createElementVNode("div", {
            class: "mask",
            id: "mask",
            style: {"display":"block"}
          }, null, -1))
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})